import CreatorProfileIncompleteBanner from './CreatorProfileIncompleteBanner'

export default CreatorProfileIncompleteBanner
